/**
 * EntityMetadata - Displays entity metadata (ID, created, updated dates)
 * Simple read-only display component for administrative metadata
 * @idempotent @atomic
 */
import { memo } from 'react'
import { formatDateTime } from '../../../utils/dateFormatting'

const EntityMetadata = memo(function EntityMetadata({ entity }) {
  if (!entity) return null

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500 mb-1">Entity ID</div>
        <div className="font-mono text-xs text-gray-900 break-all">
          {entity.id}
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500 mb-1">Created</div>
        <div className="text-sm text-gray-900">
          {formatDateTime(entity.createdAt)}
        </div>
      </div>
      
      <div className="bg-white rounded-lg shadow p-4">
        <div className="text-sm text-gray-500 mb-1">Last Updated</div>
        <div className="text-sm text-gray-900">
          {formatDateTime(entity.updatedAt)}
        </div>
      </div>
    </div>
  )
})

export default EntityMetadata
